module.exports = __webpack_public_path__ + "media/images/pattern-63d272793060f557a481f44915af1be2.svg";